import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

export const useToDoStyles = makeStyles((theme: Theme) =>
  createStyles({
    icon: {
      width: 24,
      color: 'var(--primary-blue-six)'
    },
    menuTitle: {
      color: 'var(--primary-blue-six)',
      display: 'flex',
      gap: `${theme.spacing(1)}px`,
      padding: theme.spacing(1.5, 0)
    },
    menuTitleIcon: {
      color: 'var(--primary-blue-six)'
    }
  })
);
